import { AxiosResponse } from 'axios';
import { buildPath } from '../lib/url';
import { backendClient as client } from './clients';
import { ApplicationContextDTO } from './dto';
import { GetOne } from './types';

const RESOURCE_NAME = 'application';

export const getApplicationContext: GetOne<{}, ApplicationContextDTO> = async ({ config } = {}) => {
    return client.get(buildPath([RESOURCE_NAME, 'context']), config).then((response: AxiosResponse) => response.data);
};
